/**
 * safeListener.js
 * ---------------
 * Wraps an Echo channel event handler so that a thrown error inside a store
 * method never silently kills the listener for all subsequent events.
 *
 * Before:
 *   .listen("ItemUpdated", (e) => someHandler(e))
 *   // if onItemUpdated() throws → the whole callback dies, no future events
 *
 * After:
 *   .listen("ItemUpdated", safe("ItemUpdated", (e) => someHandler(e)))
 *   // error is logged, listener stays alive
 *
 * Usage:
 *   import { safe } from "../core/safeListener";
 *   channel.listen("SomeEvent", safe("SomeEvent", (e) => myStore.handle(e)));
 */

/**
 * @param {string}   eventName  - Used in error logs so you know which event broke
 * @param {Function} handler    - The original event callback
 * @returns {Function}          - Wrapped callback, never throws
 */
export function safe(eventName, handler) {
    return (payload) => {
        console.log(`[LiveSync] Received: "${eventName} "`, payload);
        try {
            handler(payload);
        } catch (err) {
            console.error(`[LiveSync] Error in event "${eventName}":`, {
                error: err.message,
                stack: err.stack,
                payload: payload,
            });
        }
    };
}
